const RightQuick = () => {
  return (
    <>
      <div className="hidden lg:block fixed right-0 top-1/2 -translate-y-48 w-fit h-fit z-10">
        <div className="grid grid-rows-2">
          <button
            type="button"
            onClick={() => window.open("https://blog.naver.com/gurobone1")}
            className=" relative w-fit h-fit max-w-24 transition-transform duration-200 hover:shadow-md rounded-lg"
          >
            <img
              src="/images/iconBlog.png"
              alt="naverTalk"
              className="!relative w-full h-full object-contain"
            />
          </button>
          <button
            type="button"
            onClick={() => window.open("https://open.kakao.com/o/s3YAT29h")}
            className=" relative w-fit h-fit max-w-24 transition-transform duration-200 hover:shadow-md rounded-lg -mt-0.5"
          >
            <img
              src="/images/iconKakao.png"
              alt="kakao"
              className="!relative w-full h-full object-contain"
            />
          </button>
        </div>
      </div>
    </>
  );
};

export default RightQuick;
